export class SaveModuleConfigModel {
  public namespaceMap?: { [key: string]: string } = {};
  public duplicate = false;
  public replace = false;

  constructor (init?: Partial<SaveModuleConfigModel>) {
    Object.assign(this, init);
  }
}
